function injectStyle (ssrContext) {
  require("!!../../../../../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-4a5d3a53\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PriceStatus.vue")
}
var Component = require("!../../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PriceStatus.vue"),
  /* template */
  require("!!../../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-4a5d3a53\",\"hasScoped\":true,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"}}!../../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PriceStatus.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-4a5d3a53",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/tool/batch/shared/filters/marketplace/PriceStatus.vue
// module id = 43
// module chunks = 0